/*****************************************
VANILLA JS - LOAD EVENTS
******************************************/

// functions for run events after page loaded , async load scripts, and events with conditions (scroll, click, etc)
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x => {
    const isDocument = x.el === document;
    if (x.evt && !isDocument) {
      if (
        x.evt === arguments[0].type &&
        x.el === arguments[0].target
        ) {
        x.el.removeEventListener(x.evt, _checkafterLoadEvents);
        if (typeof (x.f) == 'function') {
          setTimeout(x.f, 0);
        }
        else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x), 1);
      }
    }
    else {
      if (typeof (x.f) == 'function') {
        setTimeout(x.f, 0);
      }
      else {
        window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x), 1);
    }
  });
  if (window.afterLoadWithEvents.length == 0) {
    window.removeEventListener('scroll', _checkafterLoadEvents);
  }
}

function register() {
  const htmlElement = document.documentElement;
  htmlElement.classList.remove('no-js');
  htmlElement.classList.add('js');

  if (window.ReadyScript) {
    window.ReadyScript.forEach(x => {
      loadScript(x.s, x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x => {
      if (x.p != undefined) {
        window[x.f].apply(x.p);
      } else {
        window[x.f].apply();
      }
    });
  }

  if (window.afterLoadWithEvents) {
    window.addEventListener('scroll', _checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x => {
      if (x.evt) {
        x.el.addEventListener(x.evt, _checkafterLoadEvents);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => register());

// Load scripts after page load

function loadScript(sc, callback) {
  if (Array.isArray(sc)) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = sc[0];
    sc.splice(0, 1);
    if (sc.length > 0) {
      script.addEventListener("load", () => loadScript(sc, callback));
    } else if (callback !== undefined) {
      script.addEventListener("load", () => {
        window[callback].apply();
      });
    }
    document.body.appendChild(script);
  } else {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = sc;

    if (callback !== undefined) {
      script.addEventListener("load", () => {
        window[callback].apply();
      });
    }
    document.body.appendChild(script);
  }
}

/*****************************************
VANILLA JS - HELPER FUNCTIONS
******************************************/
function fadeIn(el, displayValue, delay) {
  clearTimeout(el._fadeTimeout);
  el._fadeTimeout = setTimeout(() => {
    el.style.display = displayValue;
    el.style.visibility = 'visible';
    el.style.opacity = '0';
    el.style.transition = 'opacity 400ms';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });
    });
  }, delay);
}

function fadeOut(el, delay) {
  clearTimeout(el._fadeTimeout);
  el._fadeTimeout = setTimeout(() => {
    el.style.transition = 'opacity 400ms';
    el.style.opacity = '0';
    el._transitionTimeout = setTimeout(() => {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
    }, 400);
  }, delay);
}

function stopFade(el, jumpToEnd) {
  clearTimeout(el._fadeTimeout);
  clearTimeout(el._transitionTimeout);
  el.style.transition = 'none';
  if (jumpToEnd) {
    // leave as-is; caller decides next state
  }
}

let slideUp = (el, duration = 400) => {
  if (!el._sliding) el._sliding = true;

  el.style.height = el.offsetHeight + 'px';
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.offsetHeight; // force reflow

  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;

  window.setTimeout(() => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el._sliding = false;
  }, duration);
};

let slideDown = (el, duration = 400) => {
  if (!el._sliding) el._sliding = true;
  el.style.display = 'block';  // set this FIRST before anything else
  let height = el.scrollHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight; // force reflow
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el._sliding = false;
  }, duration);
};

let slideToggle = (el, duration = 400) => {
  if (window.getComputedStyle(el).display === 'none') {
    slideDown(el, duration);
  } else {
    slideUp(el, duration);
  }
};

// Show Loader
function loader(isShow) {
  const loaderEl = document.querySelector('.loader');
  if (loaderEl) loaderEl.style.display = isShow ? 'block' : 'none';
}

/******************************************
VANILLA JS - ACCORDION
******************************************/
function initAccordion(selector, options = {}) {
  const titles = document.querySelectorAll(selector);
  const duration = options.duration || 400;
  const allowMultiple = options.allowMultiple || false; // open multiple panels if true

  titles.forEach(title => {
    title.addEventListener('click', handleAccordion);
    title.addEventListener('keypress', handleAccordion);
  });

  function handleAccordion(event) {
    if (event.type !== 'click' && !(event.type === 'keypress' && (event.key === 'Enter' || event.keyCode === 13))) return;

    const panel = event.currentTarget.nextElementSibling;

    if (!allowMultiple) {
      // Close all other panels
      titles.forEach(t => {
        const p = t.nextElementSibling;
        if (t !== event.currentTarget && t.classList.contains('active')) {
          if (!p._sliding) slideUp(p, duration);
          t.classList.remove('active');
          t.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Toggle current panel
    if (!panel._sliding) {
      if (event.currentTarget.classList.contains('active')) {
        slideUp(panel, duration);
        event.currentTarget.classList.remove('active');
        event.currentTarget.setAttribute('aria-expanded', 'false');
      } else {
        slideDown(panel, duration);
        event.currentTarget.classList.add('active');
        event.currentTarget.setAttribute('aria-expanded', 'true');
      }
    }
  }
}
initAccordion('.faqs-accordion__title', { duration: 400, allowMultiple: false });
initAccordion('.product-accordion__title', { duration: 400, allowMultiple: false });
initAccordion('.footer-content__accordion-header', { duration: 400, allowMultiple: true });

/******************************************
VANILLA JS - ACCOUNT TABS
******************************************/
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.account .tab');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabId = tab.getAttribute('data-tab');

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('account__tab--active'));

      // Hide all tab content
      document.querySelectorAll('.account__content').forEach(content => {
        content.style.display = 'none';
      });

      // Activate clicked tab
      tab.classList.add('account__tab--active');

      // Show the corresponding content
      const activeContent = document.getElementById(tabId);
      if (activeContent) {
        activeContent.style.display = '';
      }
    });
  });
});

/******************************************
VANILLA JS - CANVAS CART
******************************************/
(function () {

  var canvasCart = document.querySelector('.canvas-cart');
  var canvasContent = document.querySelector('.c-offcanvas-content-wrap');
  var canvasOverlay = document.querySelector('.c-offcanvas-bg');
  var triggers = document.querySelectorAll('.js-offcanvas-trigger-left, [data-offcanvas-trigger]');
  var closebtns = document.querySelectorAll('.js-offcanvas-close');

  if (!canvasCart) return;

  function openCart() {
    canvasCart.classList.remove('is-closed');
    canvasCart.classList.add('is-open');
    if (canvasOverlay) { canvasOverlay.classList.remove('is-closed'); canvasOverlay.classList.add('is-open'); }
    if (canvasContent) canvasContent.classList.add('is-open', 'c-offcanvas-content-wrap--right', 'c-offcanvas-content-wrap--overlay');
    document.documentElement.classList.add('has-offcanvas--visible');
  }

  function closeCart() {
    canvasCart.classList.remove('is-open');
    if (canvasOverlay) {
      canvasOverlay.classList.remove('is-open');
      canvasOverlay.classList.add('is-animating', 'c-offcanvas-bg--closing');
    }
    if (canvasContent) canvasContent.classList.remove('is-open', 'c-offcanvas-content-wrap--right', 'c-offcanvas-content-wrap--overlay');
    document.documentElement.classList.remove('has-offcanvas--visible');

    setTimeout(function() {
      canvasCart.classList.add('is-closed');
      if (canvasOverlay) {
        canvasOverlay.classList.remove('is-animating', 'c-offcanvas-bg--closing');
        canvasOverlay.classList.add('is-closed');
      }
    }, 500);
  }

  function toggleCart() {
    canvasCart.classList.contains('is-open') ? closeCart() : openCart();
  }

  // Trigger buttons (open/toggle)
  triggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCart();
    });
  });

  // Close buttons
  closebtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  // Close on overlay click (clicks outside the cart panel itself)
  document.addEventListener('click', function (e) {
    if (
      canvasCart.classList.contains('is-open') &&
      !canvasCart.contains(e.target) &&
      !e.target.closest('.js-offcanvas-trigger-left, [data-offcanvas-trigger]')
    ) {
      closeCart();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // Shim for ajaxify.js
  window.dataOffcanvas = {
    toggle: toggleCart,
    open:   openCart,
    close:  closeCart
  };

})();

/******************************************
VANILLA JS - MONEY FORMATTING
Replaces Shopify.formatMoney from the legacy option_selection.js.
Takes an amount in the currency's subunit (pence) and a money format
string, e.g. formatMoney(1250, "£{{amount}}") -> "£12.50"
Supports the same placeholders as Shopify's money formats.
******************************************/
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');

  var placeholder = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '{{amount}}';
  var match = formatString.match(placeholder);
  if (!match) return formatString;

  function withDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return units + (parts[1] ? decimal + parts[1] : '');
  }

  var value;
  switch (match[1]) {
    case 'amount_no_decimals':                        value = withDelimiters(cents, 0, ',', '.'); break;
    case 'amount_with_comma_separator':               value = withDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator':   value = withDelimiters(cents, 0, '.', ','); break;
    case 'amount_with_apostrophe_separator':          value = withDelimiters(cents, 2, "'", '.'); break;
    case 'amount_no_decimals_with_space_separator':   value = withDelimiters(cents, 0, ' ', ','); break;
    case 'amount_with_space_separator':               value = withDelimiters(cents, 2, ' ', ','); break;
    case 'amount_with_period_and_space_separator':    value = withDelimiters(cents, 2, ' ', '.'); break;
    default:                                          value = withDelimiters(cents, 2, ',', '.'); break;
  }
  return formatString.replace(placeholder, value);
}

/******************************************
VANILLA JS - CART DISCOUNT
Cart AJAX API: POST /cart/update.js with a `discount` parameter.
  { discount: 'CODE' }         applies CODE (replaces any codes already on the cart)
  { discount: 'CODE1,CODE2' }  applies several codes
  { discount: '' }             removes all codes
The cart UI (line prices, totals, applied code, error) is then
re-rendered by _updateCartContent() in ajaxify-cart.js.
******************************************/
var cartDiscountPending = false;

// True if `code` is applied in the cart JSON returned by /cart/update.js
function isDiscountCodeApplied(cart, code) {
  var target = code.toLowerCase();

  // If the response includes discount_codes, use its applicable flag
  if (Array.isArray(cart.discount_codes)) {
    return cart.discount_codes.some(function (d) {
      return String(d.code).toLowerCase() === target && d.applicable !== false;
    });
  }

  // Otherwise look for a discount-code application on the cart or its lines
  var applications = (cart.cart_level_discount_applications || []).slice();
  (cart.items || []).forEach(function (item) {
    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      if (allocation.discount_application) applications.push(allocation.discount_application);
    });
  });
  return applications.some(function (app) {
    return app.type === 'discount_code' && String(app.title).toLowerCase() === target;
  });
}

function postCartDiscount(discount) {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ discount: discount })
  }).then(function (response) {
    if (!response.ok) throw new Error('Cart discount update failed (' + response.status + ')');
    return response.json();
  });
}

function updateCartDiscount(discountCode) {
  var code = (discountCode || '').trim();
  var wrapper = document.querySelector('.cart-discount');

  if (cartDiscountPending) return Promise.resolve();
  cartDiscountPending = true;
  if (wrapper) wrapper.classList.add('is-loading');

  return postCartDiscount(code)
    .then(function (cart) {
      if (code === '' || isDiscountCodeApplied(cart, code)) return false;
      // Invalid, expired or not applicable to this cart: take it back off so
      // checkout matches what the cart shows, then flag the error.
      return postCartDiscount('').then(function () { return true; });
    })
    .catch(function (error) {
      console.error(error);
      return code !== '';
    })
    .then(function (showError) {
      _updateCartContent(showError);
    })
    .finally(function () {
      cartDiscountPending = false;
      if (wrapper) wrapper.classList.remove('is-loading');
    });
}

// Apply / remove (delegated; preventDefault so the cart <form> never submits)
document.addEventListener('click', function (e) {
  var applyBtn = e.target.closest('[data-action="discountcode"]');
  var removeBtn = e.target.closest('[data-action="discountremove"]');
  if (!applyBtn && !removeBtn) return;
  e.preventDefault();

  var input = document.querySelector('[data-discountcode]');

  if (applyBtn) {
    if (!input || input.value.trim() === '') {
      if (input) input.focus();
      return;
    }
    updateCartDiscount(input.value);
  } else {
    updateCartDiscount('').then(function () {
      if (input) input.value = '';
    });
  }
});

// Enter in the code field applies the code instead of submitting the cart form
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' || !e.target.matches('[data-discountcode]')) return;
  e.preventDefault();
  if (e.target.value.trim() !== '') updateCartDiscount(e.target.value);
});

/******************************************
VANILLA JS - COLLECTION INTRO TOGGLE
******************************************/
document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.collection__toggle');

  toggleButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault(); // prevent default link behavior

      // Toggle the visibility class on the description content
      const content = document.querySelector('.collection__description-content');
      if (content) {
        content.classList.toggle('collection__description-content--visible');
      }
    });
  });
});

/******************************************
VANILLA JS - COOKIE FUNCTION
******************************************/
// Cookie Set
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

// Cookie Get
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

/******************************************
VANILLA JS - COUNTRY / CURRENCY SELECTOR
Submits the localization form as soon as a country is picked.
Shopify redirects back to the same page in that country's currency.
******************************************/
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-localization-select]')) return;
  if (e.target.form) e.target.form.submit();
});

/******************************************
VANILLA JS - FEATURED COLLECTION TABS
******************************************/
document.querySelectorAll('.featured-collection__tab').forEach(function(tabEl) {
  tabEl.addEventListener('click', function() {
    var tab = this.dataset.tab;
    document.querySelectorAll('.featured-collection__tab').forEach(function(el) {
      el.classList.remove('featured-collection__tab--active');
    });
    document.querySelectorAll('.featured-collection__tab-content').forEach(function(el) {
      el.classList.remove('featured-collection__tab-content--active');
    });
    this.classList.add('featured-collection__tab--active');
    document.getElementById(tab).classList.add('featured-collection__tab-content--active');
  });
});

/******************************************
VANILLA JS - FINANCE POPUPS
******************************************/
function initFinancePopups() {
  const html = document.documentElement;

  function openPopup(type) {
    const popup = document.getElementById(`finance-popup-${type}`);
    if (!popup) return;
    // Close any open popup first
    closeAllPopups();
    popup.classList.add('product-finance-popup--active');
    html.classList.add('noscroll-finance-popup');
  }

  function closeAllPopups() {
    document.querySelectorAll('.product-finance-popup--active').forEach(popup => {
      popup.classList.remove('product-finance-popup--active');
    });
    html.classList.remove('noscroll-finance-popup');
  }

  // Handle ALL clicks in one listener (event delegation)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-finance-popup]');
    const closeBtn = e.target.closest('[data-finance-close]');
    const activePopup = document.querySelector('.product-finance-popup--active');
    // Open
    if (trigger) {
      const type = trigger.getAttribute('data-finance-popup');
      openPopup(type);
      return;
    }
    // Close via button
    if (closeBtn) {
      closeAllPopups();
      return;
    }
    // Close on overlay click ONLY
    if (
      activePopup &&
      e.target.closest('.product-finance-popup') && // clicked inside overlay
      !e.target.closest('.product-finance-popup__popup') // but NOT inside panel
    ) {
      closeAllPopups();
    }
  });

  // ESC key support (bonus UX)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllPopups();
    }
  });
}
initFinancePopups();

/******************************************
VANILLA JS - HEADER STICKY
******************************************/
let previousScroll = 0;
let headerOrgOffset = 0;
const header = document.querySelector('.header');

if (header) headerOrgOffset = header.getBoundingClientRect().top + window.scrollY;

window.addEventListener('scroll', function () {
  if (header) {
    const currentScroll = window.scrollY;
    const isNoScroll = document.documentElement.classList.contains('no-scroll');

    if (!isNoScroll) {
      if (currentScroll > headerOrgOffset) {
        if (currentScroll > previousScroll) {
          header.classList.remove('header--sticky');
        } else {
          header.classList.add('header--sticky');
        }
      } else {
        header.classList.remove('header--sticky');
      }
    }

    previousScroll = currentScroll;
  }
});

/******************************************
VANILLA JS - LAZYLOAD
******************************************/
document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

/******************************************
VANILLA JS - LIGHTGALLERY
******************************************/
// LightGallery Popup - Product Page
const lightgalleryEl = document.getElementById('lightgallery');
if (lightgalleryEl) {
  lightGallery(lightgalleryEl, {
    selector: '.product-images__item-image',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    }
  });
}

// LightGallery Popup - Gallery Page 
const lightgallerypageEl = document.getElementById('lightgallerypage');
if (lightgallerypageEl) {
  lightGallery(lightgallerypageEl, {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    }
  });
}

/******************************************
VANILLA JS - MEGA NAV
******************************************/

// Set initial display types but keep hidden
document.querySelectorAll(".nav__mega .nav__sub-menu").forEach(el => {
  el.style.display = 'flex';
  el.style.opacity = '0';
  el.style.display = 'none';
});
document.querySelectorAll(".nav__single .nav__sub-menu").forEach(el => {
  el.style.display = 'block';
  el.style.opacity = '0';
  el.style.display = 'none';
});

// Store display value per element before hiding
function getDisplayValue(el) {
  if (el.closest(".nav__mega")) return 'flex';
  return 'block';
}

const navOverlay = document.querySelector('.nav-overlay');

document.querySelectorAll(".nav__dropdown").forEach(dropdown => {
  const subMenu = dropdown.querySelector(":scope > .nav__sub-menu");

  dropdown.addEventListener("mouseenter", () => {
    if (window.innerWidth > 1279) {
      if (navOverlay) { stopFade(navOverlay); fadeIn(navOverlay, 'block', 250); }
      if (subMenu) { stopFade(subMenu); fadeIn(subMenu, getDisplayValue(subMenu), 250); }
    }
  });

  dropdown.addEventListener("mouseleave", () => {
    if (window.innerWidth > 1279) {
      if (navOverlay) { stopFade(navOverlay); fadeOut(navOverlay, 250); }
      if (subMenu) { stopFade(subMenu); fadeOut(subMenu, 250); }
    }
  });
});

// Keyboard interaction - only open on Enter
document.querySelectorAll(".nav__dropdown .nav__link").forEach(link => {
  link.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      const dropdown = link.closest(".nav__dropdown");
      const subMenu = dropdown ? dropdown.querySelector(":scope > .nav__sub-menu") : null;

      if (subMenu) {
        const isVisible = subMenu.style.display !== 'none' && subMenu.style.opacity !== '0';

        // Close all other open submenus and overlay first
        document.querySelectorAll(".nav__dropdown").forEach(otherDropdown => {
          if (otherDropdown !== dropdown) {
            const otherSubMenu = otherDropdown.querySelector(":scope > .nav__sub-menu");
            const otherSpans = otherDropdown.querySelectorAll(":scope > .nav__link > span");
            if (otherSubMenu) { stopFade(otherSubMenu); fadeOut(otherSubMenu, 0); }
            otherSpans.forEach(span => { stopFade(span); fadeOut(span, 0); });
          }
        });

        if (isVisible) {
          stopFade(subMenu);
          fadeOut(subMenu, 0);
          if (navOverlay) { stopFade(navOverlay); fadeOut(navOverlay, 0); }
        } else {
          stopFade(subMenu);
          fadeIn(subMenu, getDisplayValue(subMenu), 0);
          if (navOverlay) { stopFade(navOverlay); fadeIn(navOverlay, 'block', 0); }
        }
      }

      e.preventDefault();
    }
  });
});

/******************************************
VANILLA JS - MOBILE NAV
******************************************/
document.addEventListener('DOMContentLoaded', function () {

  // Remove inline display: none set by Shopify
  const headerNav = document.querySelector('.header-nav');
  if (headerNav) headerNav.style.display = '';

  // Clone
  document.querySelectorAll('.nav__sub-menu').forEach(function (menu) {
    const clone = document.createElement('div');
    Array.from(menu.attributes).forEach(attr => {
      clone.setAttribute(attr.name, attr.value);
    });
    clone.classList.add('nav__sub-menu--cloned');
    const wrap = document.createElement('ul');
    wrap.classList.add('nav__sub-menu__wrap');
    const source = menu.cloneNode(true);
    while (source.firstChild) wrap.appendChild(source.firstChild);
    clone.appendChild(wrap);
    document.querySelector('.header-nav').insertAdjacentElement('afterend', clone);
  });

  // Open & Close Nav (Mobile) - Click Function
  const headerMobile = document.querySelector('.header-mobile');
  if (headerMobile) {
    headerMobile.addEventListener('click', function () {
      const overlay = document.querySelector('.mobile-nav-overlay');
      const isActive = this.classList.contains('header-mobile--active');

      this.classList.toggle('header-mobile--active');
      document.querySelector('.header-announcements')?.classList.toggle('header-announcements--hide');
      document.querySelector('.header-nav')?.classList.toggle('header-nav--active');
      document.documentElement.classList.toggle('no-scroll-mobile-nav');
      overlay.style.display = overlay.style.display === 'none' ? 'block' : 'none';
      document.querySelectorAll('.nav__sub-menu--cloned').forEach(el => el.classList.remove('nav__sub-menu--active'));
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));

      if (isActive) {
        // Closing — add off class after 1s
        setTimeout(() => {
          document.querySelector('.header-nav')?.classList.add('header-nav--off');
        }, 300);
      } else {
        // Opening — remove off class immediately
        document.querySelector('.header-nav')?.classList.remove('header-nav--off');
      }
    });
  }

  // Close Nav (Mobile) - Click Function
  const overlay = document.querySelector('.mobile-nav-overlay');
  if (overlay) {
    overlay.addEventListener('click', function () {
      document.querySelector('.header-mobile')?.classList.remove('header-mobile--active');
      document.querySelector('.header-announcements')?.classList.remove('header-announcements--hide');
      document.querySelector('.header-nav')?.classList.remove('header-nav--active');
      document.documentElement.classList.remove('no-scroll-mobile-nav');
      this.style.display = 'none';
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));
      document.querySelectorAll('.nav__sub-menu--cloned').forEach(el => el.classList.remove('nav__sub-menu--active'));

      // Closing via overlay — add off class after 1s
      setTimeout(() => {
        document.querySelector('.header-nav')?.classList.add('header-nav--off');
      }, 300);
    });
  }

  // Open Sub Menu - Click Function
  document.querySelectorAll('.nav__dropdown .nav__link').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (window.innerWidth < 1280) {
        event.preventDefault();
      }
      const id = this.getAttribute('id');
      document.querySelectorAll('.nav__sub-menu').forEach(function (menu) {
        const dataid = menu.getAttribute('data-id');
        console.log(dataid);
        if (id === dataid) {
          menu.classList.add('nav__sub-menu--active');
        }
      });
      document.querySelectorAll('.nav').forEach(el => el.classList.add('nav--hidden'));
    });
  });

  // Top-level "#" links only open their dropdown - never navigate (stops the jump to top of page on desktop)
  document.querySelectorAll('.nav__link--no-url').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });

  // Back Button - Click Function
  document.querySelectorAll('.nav__sub-menu__back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.nav__sub-menu').forEach(el => el.classList.remove('nav__sub-menu--active'));
      document.querySelectorAll('.nav').forEach(el => el.classList.remove('nav--hidden'));
    });
  });

});

/******************************************
VANILLA JS - MOBILE SEARCH TOGGLE
******************************************/
document.addEventListener('DOMContentLoaded', function () {

  const form = document.querySelector('.header-search__form');
  const siteContainer = document.querySelector('.site-container');

  document.querySelectorAll('.header-search__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      form?.classList.toggle('header-search__form--visible');
      siteContainer?.classList.toggle('site-container--blackout');
      document.querySelector('.header-search__input')?.focus();
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header-search')) {
      siteContainer?.classList.remove('site-container--blackout');
      form?.classList.remove('header-search__form--visible');
    }
  });

});

/******************************************
VANILLA JS - POPUP (GENERAL)
******************************************/

// Popup - Open
document.querySelectorAll('[data-popup]').forEach(function(el) {
  el.addEventListener('click', function() {
    var popup = this.getAttribute('data-popup');
    document.getElementById('popup-' + popup).classList.add('popup--active');
    document.documentElement.classList.add('noscroll-popup');
  });
});

// Popup - Close
document.querySelectorAll('.popup__close').forEach(function(el) {
  el.addEventListener('click', function() {
    document.querySelectorAll('.popup').forEach(function(popup) {
      popup.classList.remove('popup--active');
    });
    document.documentElement.classList.remove('noscroll-popup');
  });
});

/******************************************
VANILLA JS - PRODUCT CARD SWATCHES
******************************************/

function resetCardSlider(productCard) {
  const swiperEl = productCard.querySelector('.swiper--product-card');
  if (swiperEl && swiperEl.swiper) {
    swiperEl.swiper.slideTo(0, 0);
  }
}

function getSwatchLink(target) {
  if (!target || !target.closest) return null;
  const col = target.closest('.swatches__col');
  if (!col || !col.closest('.product-card__swatches')) return null;
  return col.matches('a') ? col : col.querySelector('a[data-product-url]');
}

function showSwatchData(link, mode) {
  const productCard = link.closest('.product-card');
  if (!productCard) return;

  resetCardSlider(productCard);

  const productImage = productCard.querySelector('.product-card__image');
  const productTitle = productCard.querySelector('.product-card__title');
  const productPrice = productCard.querySelector('.product-card__price-current');
  const productComparePrice = productCard.querySelector('.product-card__price-compare');
  const priceFromLabel = productCard.querySelector('.product-card__price-from');
  const productLink = productCard.querySelector('.product-card__image-link');
  const savingText = productCard.querySelector('.product-card__price-saving');
  const priceContainer = productCard.querySelector('.product-card__price');
  const overlayContainer = productCard.querySelector('.product-card__overlays');

  // On mouseleave, restore the card's own data
  const ds = mode === 'mouseleave' ? productCard.dataset : link.dataset;

  // Never swap to Shopify's "no-image" placeholder
  if (ds.imageUrl && ds.imageUrl.indexOf('no-image') === -1) {
    productImage.src = ds.imageUrl;
    productImage.srcset = ds.imageSrcset || '';
  }

  if (ds.title) {
    productTitle.textContent = ds.title;
    productTitle.title = ds.title;
  }

  if (ds.price) {
    productPrice.textContent = ds.price;
  }

  // "From" pricing (data-price-from="true|false")
  const priceFrom = ds.priceFrom === 'true';
  if (priceFromLabel) priceFromLabel.style.display = priceFrom ? 'inline' : 'none';
  priceContainer.classList.toggle('product-card__price--from', priceFrom);

  // Zero-priced products: smaller "£ Custom Pricing" text, VAT label hidden
  const customPrice = ds.customPrice === 'true';
  productCard.querySelectorAll('.product-card__price').forEach(el => {
    el.classList.toggle('product-card__price--custom', customPrice);
  });

  const onSale = ds.comparePrice && ds.onSale === 'true';

  savingText.textContent = onSale ? ds.saving : '';
  savingText.style.display = onSale ? 'inline' : 'none';

  productComparePrice.textContent = onSale ? ds.comparePrice : '';
  productComparePrice.style.display = onSale ? 'inline' : 'none';
  priceContainer.classList.toggle('product-card__price--on-sale', !!onSale);

  overlayContainer.innerHTML = ds.overlays || '';

  if (ds.productUrl) {
    productLink.href = ds.productUrl;
    productTitle.href = ds.productUrl;
  }
}

function setCurrentSwatch(link) {
  const container = link.closest('.product-card__swatches');
  container.querySelectorAll('.swatches__swatch--current').forEach(el => {
    el.classList.remove('swatches__swatch--current');
  });
  link.querySelector('.swatches__swatch')?.classList.add('swatches__swatch--current');
}

document.addEventListener('DOMContentLoaded', function () {

  // Desktop hover (capture phase, only act on the column element itself)
  ['mouseenter', 'mouseleave'].forEach(type => {
    document.addEventListener(type, function (e) {
      if (window.innerWidth < 1280) return;
      if (!e.target.classList || !e.target.classList.contains('swatches__col')) return;
      const link = getSwatchLink(e.target);
      if (link) showSwatchData(link, type);
    }, true);
  });

  // Tablet & mobile: first tap previews, second tap follows the link
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 1280) return;
    const link = getSwatchLink(e.target);
    if (!link) return;

    const cardLink = link.closest('.product-card').querySelector('.product-card__image-link');
    if (cardLink.href.endsWith(link.dataset.productUrl)) return; // already showing, let it navigate

    e.preventDefault();
    setCurrentSwatch(link);
    showSwatchData(link, 'click');
  }, true);

  // Reset to first swatch only when resizing from tablet/mobile up to desktop.
  // Browsers fire resize during load (scrollbar appearing, panels opening), so
  // running this on every resize was overwriting the card image unprompted.
  let wasDesktop = window.innerWidth >= 1280;
  window.addEventListener('resize', function () {
    const isDesktop = window.innerWidth >= 1280;
    const crossedUp = isDesktop && !wasDesktop;
    wasDesktop = isDesktop;
    if (!crossedUp) return;
    document.querySelectorAll('.product-card__swatches').forEach(container => {
      const firstLink = getSwatchLink(container.querySelector('.swatches__col'));
      if (!firstLink) return;
      setCurrentSwatch(firstLink);
      showSwatchData(firstLink, 'click');
    });
  });
});

/******************************************
VANILLA JS - SCROLL LINK (SMOOTH)
*****************************************/
document.addEventListener("DOMContentLoaded", function () {
  // Applies to .scroll-link plus hero buttons, so a hero button URL like
  // "/#shop-collections" glides down to the section with that Custom ID.
  const scrollLinkSelector = ".scroll-link, .hero-text__button, .hero-video__button";
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.addEventListener("click", function (e) {
    const target = e.target.closest(scrollLinkSelector);
    if (!target || !target.hash || target.target === "_blank") return;
    // Only intercept links to this page; "/#id" from another page navigates normally
    if (target.pathname !== window.location.pathname || target.host !== window.location.host) return;

    const targetEl = document.getElementById(decodeURIComponent(target.hash.slice(1)));
    if (!targetEl) return;

    e.preventDefault();
    targetEl.scrollIntoView({ behavior: reduceMotion.matches ? "auto" : "smooth", block: "start" });
    if (history.pushState) history.pushState(null, "", target.hash);
  });
});

/******************************************
VANILLA JS - SWIPER SLIDER
******************************************/

// Swiper Slider - Default
var productImagesSwiper;

// Timer-based autoplay: only runs while the slider is on screen and the tab is visible,
// pauses on hover/focus, and restarts the countdown after the visitor interacts.
function liteAutoplay(swiper, el, delay) {
  if (!swiper || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var timer = null, visible = true, paused = false;
  function tick() {
    if (swiper.destroyed || document.hidden || !visible || paused) return;
    if (swiper.isEnd && !swiper.params.loop) { swiper.slideTo(0); } else { swiper.slideNext(); }
  }
  function start() { if (!timer) timer = setInterval(tick, delay); }
  function stop() { clearInterval(timer); timer = null; }
  function restart() { stop(); start(); }
  el.addEventListener('mouseenter', function () { paused = true; });
  el.addEventListener('mouseleave', function () { paused = false; restart(); });
  el.addEventListener('focusin', function () { paused = true; });
  el.addEventListener('focusout', function () { paused = false; restart(); });
  swiper.on('touchEnd', restart);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) { start(); } else { stop(); }
    }).observe(el);
  } else {
    start();
  }
}

// Swiper set-up.
// Carousels on or near the screen are set up straight away; the rest are set up
// when they scroll near the viewport. Setting up every carousel at load forced a
// layout calculation per carousel (Lighthouse "Forced reflow") and added main-thread work.
var swiperCount = 0;
var swiperObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (!entry.isIntersecting) return;
    swiperObserver.unobserve(entry.target);
    setupSwiper(entry.target);
  });
}, { rootMargin: '300px 0px' }) : null;

function initSwipers() {
  var viewportH = window.innerHeight || document.documentElement.clientHeight;
  var pending = [];
  document.querySelectorAll('.swiper--default').forEach(function (el) {
    if (el.classList.contains('swiper-initialized') || el.dataset.swiperQueued) return;
    el.dataset.swiperQueued = 'true';
    pending.push(el);
  });
  // Read all positions first, then set up - avoids interleaved layout reads/writes
  var rects = pending.map(function (el) { return el.getBoundingClientRect(); });
  pending.forEach(function (el, i) {
    var r = rects[i];
    var visible = r.width > 0 && r.bottom > -300 && r.top < viewportH + 300;
    if (visible || !swiperObserver) { setupSwiper(el); } else { swiperObserver.observe(el); }
  });
}

function setupSwiper(el) {
    if (el.classList.contains('swiper-initialized')) return;
    var index = swiperCount++;
    el.classList.add('swiper-' + index);

    const pagination = el.querySelector('.swiper-pagination');
    const buttonPrev = el.querySelector('.swiper-button-prev');
    const buttonNext = el.querySelector('.swiper-button-next');
    const scrollbar  = el.querySelector('.swiper-scrollbar');

    // Swiper's built-in autoplay runs a requestAnimationFrame loop on every frame for as long as it
    // is running (to emit autoplayTimeLeft). We use a simple timer instead - see liteAutoplay().
    const $autoplay  = false;
    const $freemode  = !el.classList.contains('swiper--snap');
    const $centre    = !el.classList.contains('swiper--left');

    // Pass elements (not '.class-N' selectors) so re-running initSwipers() can't target the wrong carousel
    const $pagination      = pagination || null;
    const $pagination_type = el.querySelector('.swiper-pagination--fraction') ? 'fraction' : 'bullets';
    const $next            = buttonNext || null;
    const $prev            = buttonPrev || null;
    const $scrollbar       = scrollbar  || null;

    const $wrapper = el.querySelector('.swiper-wrapper');
    const $slideRole = ($wrapper && $wrapper.tagName === 'UL') ? 'listitem' : 'group';

    const swiper = new Swiper(el, {
        a11y: {
          slideRole: $slideRole,
        },
        autoplay: $autoplay,
        slidesPerView: 'auto',
        centerInsufficientSlides: $centre,
        navigation: {
          prevEl: $prev,
          nextEl: $next,
        },
        pagination: {
          el: $pagination,
          type: $pagination_type,
          // Product-card dots sit inside the card's <a>, so make them indicators only:
          // no nested focusable buttons, and no 10px touch targets (WCAG 2.5.8).
          clickable: !el.classList.contains('swiper--product-card'),
        },
        scrollbar: {
          el: $scrollbar,
          draggable: true,
          snapOnRelease: false,
        },
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: {
          enabled: $freemode,
          minimumVelocity: 0,
          momentumBounce: false,
          momentumRatio: 0.5,
          momentumVelocityRatio: 1.5,
        },
      });

    if (el.classList.contains('swiper--autoplay')) {
      liteAutoplay(swiper, el, 4000);
    }

    if (el.classList.contains('swiper--product-card')) {
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover && swiper.slides.length > 1) {
        el.addEventListener('mouseenter', function () { swiper.slideTo(1, 0); });
        el.addEventListener('mouseleave', function () { swiper.slideTo(0, 0); });
      }
    }

    // Nav lock state (was a 50ms delayed pass over every carousel)
    setTimeout(function () {
      if (swiper.destroyed || typeof swiper.update !== 'function') return;
      swiper.update();
      const navEl = el.querySelector('.swiper-nav');
      if (swiper.isLocked && navEl) navEl.classList.add('swiper-nav--locked');
      swiper.on('lock', function () {
        const nav = el.querySelector('.swiper-nav');
        if (nav) nav.classList.add('swiper-nav--locked');
      });
      swiper.on('unlock', function () {
        const nav = el.querySelector('.swiper-nav');
        if (nav) nav.classList.remove('swiper-nav--locked');
      });
    }, 50);
}

if (document.querySelectorAll('.swiper--default').length > 0) {
  initSwipers();
}

// Swiper Slider - Product Page
if (document.querySelector('.swiper--product-images')) {
  const productThumbsSwiper = new Swiper('.swiper--product-thumbs', {
    slidesPerView: 8,
    direction: 'vertical',
    spaceBetween: 14,
  });

  productThumbsSwiper.on('click', () => {
    const clicked = productThumbsSwiper.clickedIndex;
    const first   = productThumbsSwiper.activeIndex;
    const last    = first + productThumbsSwiper.params.slidesPerView - 1;

    if (clicked === last) {
      productThumbsSwiper.slideTo(first + 1);
    } else if (clicked === first && first > 0) {
      productThumbsSwiper.slideTo(first - 1);
    }
  });

  const productSwiper = document.querySelector('.swiper--product-images');
  let $product_pagination_type = 'bullets'; // default fallback
  if (productSwiper && productSwiper.classList.contains('product-images__featured--numbers')) {
    $product_pagination_type = 'fraction';
  } 

  productImagesSwiper = new Swiper('.swiper--product-images', {
    pagination: {
      el: '.swiper-pagination--product-images',
      type: $product_pagination_type,
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next--product-images',
      prevEl: '.swiper-button-prev--product-images',
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}

/******************************************
VANILLA JS - THEME EDITOR
******************************************/

// Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

/******************************************
VANILLA JS - THIRD PARTY CLEAN UPS
******************************************/
// Prevent Font Awesome Load from 3rd Party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild = function(...args) {  
  if (!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") == -1))
    return appendElementBackup.apply(this, args);
};
const faLink = document.querySelector('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]');
if (faLink) faLink.remove();

/******************************************
VANILLA JS - VIDEO
******************************************/
// Video - General Play and Pause
const vids = document.querySelectorAll('video');

vids.forEach(vid => {
  vid.controls = false;

  vid.addEventListener('click', function () {
    this.paused ? this.play() : this.pause();
  });

  vid.addEventListener('pause', function () {
    console.log('stopped');
    this.parentElement.classList.remove('responsive-video--stopped');
  });

  vid.addEventListener('play', function () {
    console.log('playing');
    this.parentElement.classList.add('responsive-video--stopped');
  });
});

// Video Delayed (On Mousemove) - Hero Text Banner
var videoPlayer = document.getElementById('vbanner');
if(videoPlayer){
  window.afterLoadWithEvents.push(
  {
     f:'_loadVideo',
     evt:'mousemove',
     el: document
   }
  ); 
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll('video#vbanner source'),
    valVideo = document.querySelector('video#vbanner'),
    valDataSrc = 'data-src',
    valDataPoster = 'data-poster';

    if(window.innerWidth < 601 ) {
      valDataSrc = 'data-src-mobile';
      valDataPoster = 'data-poster-mobile';
    }

    for(var i = 0; i<valSources.length;i++) {
      valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function() {
      videoPlayer.play();
    });
  }
}

// Video AutoPlay - Hero Text Banner
var videoAuto = document.getElementById('vbannerauto');
if(videoAuto){
  // Video
  var valSources = document.querySelectorAll('video#vbannerauto source'),
  valVideo = document.querySelector('video#vbannerauto'),
  valDataSrc = 'data-src',
  valDataPoster = 'data-poster';

  if(window.innerWidth < 601 ) {
    valDataSrc = 'data-src-mobile';
    valDataPoster = 'data-poster-mobile';
  }

  for(var i = 0; i<valSources.length;i++) {
    valSources[i].setAttribute('src',       valSources[i].getAttribute(valDataSrc) || '');
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function() {
    videoAuto.play();
  });
}